// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RotateImage_imageWrapper__XvnMT"};